<template>
    <!-- profile navbar -->
    <div class="profile-header-nav">
        <b-navbar toggleable="lg" class="navbar-expand-lg " :type="type">
            <b-navbar-brand class="mr-auto mr-lg-0" to="/">
                <img src="@/assets/images/logo/logo.png" alt="Logo" width="40" height="40"
                    class="d-inline-block align-center" loading="lazy">
                <span class="brand-text text-primary ml-1 ">
                    SoccerPredictor
                </span>
            </b-navbar-brand>

            <b-navbar-toggle class="ml-auto" target="nav-collapse">
                <feather-icon icon="AlignJustifyIcon" size="21" class="text-white"/>
            </b-navbar-toggle>


            <b-collapse is-nav id="nav-collapse" class="navbar-collapse ">
                <b-tabs class="ml-auto profile-tabs fs-15 e_font_family">
                    <b-tab :active="activeIndex === 'home'" @click="goTo('home')">
                        <template #title>
                            <feather-icon icon="HomeIcon" />
                            <span>首页</span>
                        </template>
                    </b-tab>
                    <b-tab  :active="activeIndex === 'RecommendReports'"
                        @click="goTo('RecommendReports')">
                        <template #title>
                            <feather-icon icon="HeartIcon" class="blinking text-danger" />
                            <span class="text-danger">重心推荐</span>
                        </template>
                    </b-tab>
                    <b-tab :active="activeIndex === 'RealTimeReports'" @click="goTo('RealTimeReports')">
                        <template #title>
                            <feather-icon icon="ActivityIcon" :class="textColor" />
                            <span :class="textColor">实时战报</span>
                        </template>
                    </b-tab>

                    <b-tab :active="activeIndex === 'HistoryReports'" @click="goTo('HistoryReports')">
                        <template #title>
                            <feather-icon icon="FileTextIcon" :class="textColor" />
                            <span :class="textColor">历史战报</span>
                        </template>
                    </b-tab>
                    <b-tab :active="activeIndex === 'DownLoad'" @click="goTo('DownLoad')">
                        <template #title>
                            <feather-icon icon="DownloadIcon" :class="textColor" />
                            <span :class="textColor">软件下载</span>
                        </template>
                    </b-tab>
                    <b-tab :active="activeIndex === 'MemberBenefits'" @click="goTo('MemberBenefits')">
                        <template #title>
                            <feather-icon icon="GiftIcon" :class="textColor" />
                            <span :class="textColor">会员权益</span>
                        </template>
                    </b-tab>
                    <b-tab :active="activeIndex === 'ContactUs'" @click="goTo('ContactUs')">
                        <template #title>
                            <feather-icon icon="MailIcon" :class="textColor" />
                            <span :class="textColor">联系我们</span>
                        </template>
                    </b-tab>
                </b-tabs>
            </b-collapse>
        </b-navbar>
    </div>
</template>
<script>
export default {
    props: {
        activeIndex: {
            type: String,
            default: 'home',
        },
        type: {
            type: String,
            default: 'light',
        },
        textColor: {
            type: String,
            default: '',
        },

    },

    data() {
        return {
            token: localStorage.getItem('soccer_token')
        }
    },

    //     mounted() {

    //   },

    methods: {
        goTo(path) {
            this.$router.push(path);
        },
    },
};  
</script>

<style lang="css" scoped>
/* 定义一个闪烁动画 */
@keyframes blink {

    /* 从0%开始到100%，‌通过opacity属性在1（‌完全不透明）‌和0（‌完全透明）‌之间交替 */
    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }
}

/* 应用闪烁动画到一个类 */
.blinking {
    /* 使用无限次重复闪烁动画 */
    animation: blink 1s infinite;
}

.e_font_family {
    font-family: PingFangSC-Regular, Microsoft YaHei, Heiti, Arial, Helvetica, "sans-serif" !important;
}
</style>